import React, { useState } from "react";
import TypesOfSkillsTransversal from "./typesOfSkillsTransversal";
import paths from "@icarius-router/paths";
import { TypesOfSkillsIndicators } from "@icarius-pages/typesOfSkillsIndicators";

const TypesOfSkillsTransversalSwitch = ({ history }) => {

  const [parametersIsOpen, setParametersIsOpen] = useState(false);
  const [parameter, setParameter] = useState(null);

  const handleOpenParameterPage = (process) => {
    setParameter(process);
    setParametersIsOpen(true);
  }

  const handleGoBack = () => {
    history.push(paths.performanceDefinition);
  }

  return (
    <>
      {
        parametersIsOpen ?
          <TypesOfSkillsIndicators
            parameter={parameter}
            handleGoBack={() => setParametersIsOpen(false)}
          />
          :
          <TypesOfSkillsTransversal
            handleGoBack={handleGoBack}
            handleOpenParameterPage={handleOpenParameterPage}
          />
      }
    </>
  );
}

export default TypesOfSkillsTransversalSwitch;